// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root {
  --color-formula-dimension: var(--g-color-text-positive);
  --color-formula-measure: var(--g-color-text-info);
  --color-field-error: var(--g-color-base-danger-heavy);
}

.palette {
  display: grid;
  grid-template-columns: repeat(auto-fit, 36px);
  grid-auto-rows: 36px;
  grid-gap: 12px;
  justify-content: left;
}
.palette__custom-color-btn {
  --g-button-background-color: transparent;
  --g-button-background-color-hover: transparent;
}
.palette__custom-color-btn::before {
  content: "";
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  border: 1px solid var(--g-color-line-generic);
  border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/styles/variables.scss","webpack://./src/ui/units/wizard/components/Palette/Palette.scss"],"names":[],"mappings":"AASA;EALI,uDAAA;EACA,iDAAA;EACA,qDAAA;ACFJ;;AAFA;EACI,aAAA;EACA,6CAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AAKJ;AAHI;EACI,wCAAA;EACA,8CAAA;AAKR;AAHQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;EACA,6CAAA;EACA,kBAAA;AAKZ","sourcesContent":[null,".g-root {\n  --color-formula-dimension: var(--g-color-text-positive);\n  --color-formula-measure: var(--g-color-text-info);\n  --color-field-error: var(--g-color-base-danger-heavy);\n}\n\n.palette {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, 36px);\n  grid-auto-rows: 36px;\n  grid-gap: 12px;\n  justify-content: left;\n}\n.palette__custom-color-btn {\n  --g-button-background-color: transparent;\n  --g-button-background-color-hover: transparent;\n}\n.palette__custom-color-btn::before {\n  content: \"\";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  width: calc(100% + 2px);\n  height: calc(100% + 2px);\n  border: 1px solid var(--g-color-line-generic);\n  border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
